@if (shouldRender) {
  <div
    class="reactive-form-support-data-readiness"
    [ngClass]="severityClass"
    role="status"
    aria-live="polite"
  >
    <div class="reactive-form-support-data-readiness__summary">
      <i class="pi reactive-form-support-data-readiness__icon" [ngClass]="icon" aria-hidden="true"></i>
      <div>
        <strong>{{ title }}</strong>
        @if (summary !== '') {
          <span>{{ summary }}</span>
        }
      </div>
    </div>

    <div class="reactive-form-support-data-readiness__items">
      <span
        *ngFor="let item of items; trackBy: trackByItem"
        class="reactive-form-support-data-readiness__chip"
        [ngClass]="'reactive-form-support-data-readiness__chip--' + item.status"
        [title]="item.detail ?? ''"
      >
        <span class="reactive-form-support-data-readiness__chip-label">{{ item.label }}</span>
        <span class="reactive-form-support-data-readiness__chip-phase">{{ getPhaseLabel(item.phase) }}</span>
        <span class="reactive-form-support-data-readiness__chip-status">{{ getStatusLabel(item.status) }}</span>
      </span>
    </div>
  </div>
}
